import { createContext, useContext, useEffect, useState } from "react";
import { reContent } from "@/lib/docstate";

const DocstateContext = createContext(null);

export const DocstateProvider = ({ children }) => {
  const [data, setData] = useState(null); // null = loading
  useEffect(() => {
    reContent().then(setData).catch(() => setData({ settings: {}, agents: [], communities: [], stats: {} }));
  }, []);
  return <DocstateContext.Provider value={data}>{children}</DocstateContext.Provider>;
};

export const useDocstate = () => useContext(DocstateContext);
